import { environment } from 'src/environments/environment';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SSOConfigModel } from '../../core/_models/sso/sso.config.model';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthHTTPService } from 'src/app/core/auth/_services/auth-http';
import { AuthService, UserModel } from 'src/app/core/auth';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { MESSAGE_CONST } from 'src/app/_metronic/core/const/message.const';
import { StatusCodeData } from 'src/app/core/commons/ultis/status.code';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public isLoggedIn = false;
  private ssoConfig: SSOConfigModel;
  private authenticationEnabled = environment.AuthenticationEnabled;
  isHomeForm: boolean = true;
  isLoginForm: boolean = false;
  formHome: FormGroup;
  private nkgAuthToken = `${environment.appVersion}-${environment.NKGAUTH_KEY}`;
  private iocAccessToken = `${environment.appVersion}-${environment.IOC_ACCESS_TOKEN_KEY}`;
  private iocRefreshToken = `${environment.appVersion}-${environment.IOC_REFRESH_TOKEN_KEY}`;
  private iocExpiresToken = `${environment.appVersion}-${environment.IOC_EXPIRES_TOKEN_KEY}`;
  private userInfoKey = environment.userInfo;
  isLoadingForm: boolean = false;
  showPassWd: boolean = false;
  rememberMe: boolean = false;
  user$: Observable<UserModel>;
  constructor(
    private authService: AuthService,
    private authHttpService: AuthHTTPService,
    private router: Router,
    private readonly fb: FormBuilder,
    private toastTr: ToastrService,
    private _cookie: CookieService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.homeForm();
    if (this.authService.getRememberMe()) {
      const email = this.authService.getLoginId();
      const password = this.authService.getLoginPwd();
      this.rememberMe = true;
      if (email && password) {
        this.formHome.controls.email.setValue(email);
        this.formHome.controls.password.setValue(password);
      }
    }
    let isLoggedIn = this.authService.checkCredentials();
    if (isLoggedIn) {
      window.location.href = `${window.location.origin}/main`;
    }
  }

  homeForm() {
    this.formHome = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required],
    });
  }

  showFormLogin() {
    this.isHomeForm = false;
    this.isLoginForm = true;
  }

  loginSSOAction() {
    try {
      const getSsoConfig = this.authHttpService.getSsoConfig(environment.SSO_ID).pipe(
        catchError((err) => {
          window.location.href = `${window.location.origin}/error/404`;
          return of(undefined);
        })
      ).subscribe(
        (payload) => {
          this.ssoConfig = payload;
          if (this.authenticationEnabled) {
            this.isLoggedIn = this.authService.checkCredentials();
            let params = (new URL(window.location.href)).searchParams;
            let code = params.get("code");
            if (!this.isLoggedIn && code) {
              this.authService.removeAuthentication();
              this.authService.retrieveToken(code);
            } else if (!this.isLoggedIn) {
              localStorage.setItem('isUsingSSOConfig', 'true');
              this.authService.removeAuthentication();
              this.login();
            } else if (this.isLoggedIn) {
              const accessToken = this.authService.getAccessToken();
              if (accessToken) {
                window.location.href = `${window.location.origin}/main`;
              } else {
                this.authService.removeAuthentication();
                window.location.href = `${window.location.origin}/main`;
              }
            }
          }
        }
      );
    } catch (err) {
      window.location.href = `${window.location.origin}/error/404`;
    }
  }

  backToHomeForm() {
    this.isLoginForm = false;
    this.isHomeForm = true;
  }

  loginAction() {
    const formData = this.formHome;
    const email = formData.value.email;
    const password = formData.value.password;
    this.authService.setRememberMe(this.rememberMe);
    this.authService.setLoginId(email);
    this.authService.setLoginPwd(password);
    this.isLoadingForm = true;
    if (!formData.invalid) {
      this.authService.login(email, password)
        .then((res: StatusCodeData<any>) => {
          if (res.code === 200) {
            if (res.data) {
              this._cookie.delete(this.nkgAuthToken);
              localStorage.setItem('isUsingSSOConfig', 'false');
              localStorage.removeItem(this.iocAccessToken);
              localStorage.removeItem(this.iocRefreshToken);
              localStorage.removeItem(this.iocExpiresToken);
              this.authService.saveTokenNkg(res.data);
              this.authService.getUserByToken().subscribe((user) => {
                if (this.authenticationEnabled) {
                  this.isLoggedIn = this.authService.checkCredentials();
                  let params = (new URL(window.location.href)).searchParams;
                  let code = params.get("code");
                  if (!this.isLoggedIn && code) {
                    this.authService.removeAuthentication();
                    this.authService.retrieveToken(code);
                  } else if (!this.isLoggedIn) {
                    this.authService.removeAuthentication();
                  } else if (this.isLoggedIn) {
                    const accessToken = localStorage.getItem(this.iocAccessToken);
                    if (accessToken && !user.defaultPassword) {
                      window.location.href = `${window.location.origin}/main`;
                      this.isLoadingForm = false;
                    }
                    else if (accessToken && user.defaultPassword) {
                      window.location.href = `${window.location.origin}/init-password`;
                      this.isLoadingForm = false;
                    }
                    else {
                      this.authService.removeAuthentication();
                      window.location.href = `${window.location.origin}/main`;
                      this.isLoadingForm = false;
                    }
                  }
                }
              });
            }
          } else if (res.code === 500) {
            this.toastTr.error(MESSAGE_CONST.Error500);
            this.isLoadingForm = false;
            this.cd.markForCheck();
          } else {
            this.toastTr.error(res.message);
            this.isLoadingForm = false;
            this.cd.markForCheck();
          }
        });
    } else {
      this.toastTr.error('Thông tin đăng nhập chưa chính xác');
      this.isLoadingForm = false;
      this.cd.markForCheck();
    }
  }

  togglePasswordInput() {
    this.showPassWd = !this.showPassWd;
    this.cd.markForCheck();
  }

  login() {
    let loginUrl = `${this.ssoConfig.baseUrl}/${environment.SSO_CONFIG.loginUrl}?response_type=${this.ssoConfig.responseType}&client_id=${this.ssoConfig.clientID}&redirect_uri=${this.ssoConfig.redirectUri}&scope=${this.ssoConfig.scope}`;
    window.location.href = loginUrl;
  }

  logout() {
    this.authService.logout();
  }

  isControlValid(controlName: string): boolean {
    const control = this.formHome.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formHome.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formHome.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formHome.controls[controlName];
    return control.dirty || control.touched;
  }
}
